function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("g", null);

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  version: 1.1,
  id: "Capa_1",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 512 512",
  style: {
    "enableBackground": "new 0 0 512 512"
  },
  xmlSpace: "preserve"
}, props), /*#__PURE__*/React.createElement("rect", {
  x: 166.282,
  y: 227.032,
  style: {
    "fill": "#C6C5CA"
  },
  width: 45.149,
  height: 132.739
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#ACABB1"
  },
  d: "M166.287,359.764h22.507c-0.03-20.78-0.053-45.134-0.029-60.088 c0.011-7.236,4.685-13.525,11.506-15.939c3.893-1.377,8.045-3.727,11.163-7.734v-48.975h-45.149v132.736H166.287z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#D8D7DA"
  },
  d: "M260.066,70.475c0-8.529-6.978-15.507-15.507-15.507l0,0c-8.529,0-15.507,6.978-15.507,15.507v65.76 c0,6.817-5.914,12.342-12.342,12.342s-12.342-5.526-12.342-12.342v-65.35c0-7.912-5.761-14.859-13.616-15.803 c-9.363-1.125-17.398,6.242-17.398,15.393v65.76c0,6.817-5.526,12.342-12.342,12.342c-6.817,0-12.342-5.526-12.342-12.342v-65.76 c0-8.529-6.978-15.507-15.507-15.507l0,0c-8.529,0-15.507,6.978-15.507,15.507V188.39c0,39.162,32.043,71.205,71.205,71.205l0,0 c39.163,0,71.205-32.043,71.205-71.205L260.066,70.475z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#C6C5CA"
  },
  d: "M160.578,196.836l0.435-48.259c-6.817,0-12.342-5.526-12.342-12.342V70.475 c0-8.529-6.978-15.507-15.507-15.507l0,0c-8.529,0-15.507,6.978-15.507,15.507V188.39c0,39.163,32.043,71.205,71.205,71.205l0,0 c5.014,0,9.909-0.533,14.638-1.531C180.262,246.305,160.578,224.532,160.578,196.836z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#C6C5CA"
  },
  d: "M191.421,229.349c-1.064-4.133,1.424-8.346,5.557-9.409c14.4-3.708,24.457-16.682,24.457-31.551 c0-4.268,3.459-7.726,7.726-7.726c4.267,0,7.726,3.458,7.726,7.726c0,21.922-14.569,42.179-36.057,46.516 C195.413,235.998,192.32,232.835,191.421,229.349z"
})), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#CE8045"
  },
  d: "M147.818,346.717v124.24c0,22.573,18.469,41.043,41.043,41.043l0,0 c22.573,0,41.043-18.469,41.043-41.043v-124.24c0-9.952-8.067-18.018-18.018-18.018h-46.05 C155.885,328.698,147.818,336.766,147.818,346.717z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#BC6C37"
  },
  d: "M181.862,470.957v-124.24c0-9.952,8.067-18.018,18.018-18.018h-34.043 c-9.952,0-18.018,8.067-18.018,18.018v124.24c0,22.573,18.469,41.043,41.043,41.043l0,0c6.065,0,11.829-1.343,17.022-3.731 C191.746,501.77,181.862,487.466,181.862,470.957z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 330.73,
  y: 213.639,
  style: {
    "fill": "#C6C5CA"
  },
  width: 45.149,
  height: 132.739
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#ACABB1"
  },
  d: "M330.726,346.372h22.507c-0.03-20.78-0.053-45.134-0.029-60.088 c0.011-7.236,4.685-13.525,11.506-15.939c3.893-1.377,8.045-3.727,11.163-7.734v-48.975h-45.149v132.736H330.726z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#D8D7DA"
  },
  d: "M344.131,7.868c-22.71,34.865-49.914,99.489-53.698,211.55 c-0.495,14.657,11.242,26.823,25.908,26.826l59.533,0.015V17.317C375.875,0.134,353.509-6.529,344.131,7.868z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#EAEAEA"
  },
  d: "M375.875,47.673V17.328c0-17.182-22.366-23.846-31.744-9.448 c-22.71,34.865-49.914,99.489-53.698,211.549c-0.495,14.657,11.242,26.823,25.908,26.826l14.39,0.004 C330.723,245.813,326.904,135.497,375.875,47.673z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#CE8045"
  },
  d: "M312.257,312.586v158.371c0,22.573,18.469,41.043,41.043,41.043l0,0 c22.573,0,41.043-18.469,41.043-41.043V312.586c0-10.598-8.592-19.189-19.189-19.189h-43.707 C320.849,293.397,312.257,301.989,312.257,312.586z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#BC6C37"
  },
  d: "M345.226,470.957V312.586c0-10.598,8.592-19.19,19.189-19.19h-32.968 c-10.599,0-19.19,8.592-19.19,19.19v158.371c0,22.573,18.469,41.043,41.043,41.043l0,0c5.857,0,11.431-1.252,16.484-3.487 C355.36,502.132,345.226,487.675,345.226,470.957z"
}), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);

export default __webpack_public_path__ + "static/media/eat.8db1eb3f.svg";
export { SvgComponent as ReactComponent };